import { __awaiter } from "tslib";
export const getQuizMetaEditorModule = (moduleConfig) => __awaiter(void 0, void 0, void 0, function* () {
    const module = yield import(/* webpackChunkName: "quizTargetingEditorUnit" */ './getQuizMetaEditorModuleMethods');
    return module.getQuizMetaEditorModuleMethods(moduleConfig);
});
